module.exports = __webpack_public_path__ + "img/2024-16.eeae6188.jpg";